import { memo } from "react";
import * as Components from "./GroupsTableHeader.components";
import Grid from "components/primitives/Grid";
import { columnLabels, tableCells } from "../GroupsTable.config";
import { useTranslation } from "react-i18next";
import Tables from "components/Tables";

function GroupsTableHeader() {
  const { t } = useTranslation();

  return (
    <Grid
      container
      component={Components.TableHeader}
      sx={{
        paddingRight: "5px",
        // controls all header font sizings
        fontSize: "14px",
        minHeight: "48px",
        alignItems: "center",
      }}
    >
      <Grid {...tableCells.checkbox} />
      <Grid {...tableCells.name} lineHeight={0}>
        <Tables.Components.SortButton label={t(columnLabels.name)} propKey="name" sortDataType="text" />
      </Grid>
      <Grid {...tableCells.actions} />
    </Grid>
  );
}

export default memo(GroupsTableHeader);
